import { render, staticRenderFns } from "./Taobao-order.vue?vue&type=template&id=35e411e1&"
import script from "./Taobao-order.vue?vue&type=script&lang=js&"
export * from "./Taobao-order.vue?vue&type=script&lang=js&"
import style0 from "./Taobao-order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports